<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Accordian
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content content--modifier-height">
  <h2>Customized Accordian</h2>
  <div class="content__tools-wrap" *ngIf="isBrowser">
    <div class="content__row">
      <div class="c-input-check-inline">
        <input id="hasContentBelow" class="c-input-check-inline__input" type="checkbox" name="hasContentBelow"
          [(ngModel)]="hasContentBelow">
        <label for="hasContentBelow" class="c-input-check-inline__label">
          Has Content Below
        </label>
      </div>
      <div class="c-input-check-inline">
        <input id="hasIconLeftSide" class="c-input-check-inline__input" type="checkbox" name="hasIconLeftSide"
          [(ngModel)]="hasIconLeftSide">
        <label for="hasIconLeftSide" class="c-input-check-inline__label">
          Has Icon Left Side
        </label>
      </div>
      <div class="c-input-check-inline">
        <input id="hasActions" class="c-input-check-inline__input" type="checkbox" name="hasActions"
          [(ngModel)]="hasActions">
        <label for="hasActions" class="c-input-check-inline__label">
          Has Actions
        </label>
      </div>
      <div class="c-input-check-inline">
        <input id="hasDefaultExpanded" class="c-input-check-inline__input" type="checkbox" name="hasDefaultExpanded"
          [(ngModel)]="hasDefaultExpanded">
        <label for="hasDefaultExpanded" class="c-input-check-inline__label">
          Has Default Expanded
        </label>
      </div>
    </div>
    <div class="content__row">
      <input id="collapseLabel" class="c-input-group__control" aria-label="CollapseAreaLabel"
        placeholder="collapseLabel" type="text" name="collapseLabel" [(ngModel)]="collapseLabel">
      <input id="expandLabel" class="c-input-group__control" aria-label="ExpandAreaLabel" placeholder="expandLabel"
        type="text" name="expandLabel" [(ngModel)]="expandLabel">
    </div>
  </div>

  <maced-accordian-group accordianGroupId="accordianGroupId">
    <maced-accordian accordianId="accordianId1" [collapseLabel]="collapseLabel" [expandLabel]="expandLabel"
      [hasContentBelow]="hasContentBelow" [hasIconLeftSide]="hasIconLeftSide" [hasActions]="hasActions"
      [hasDefaultExpanded]="hasDefaultExpanded" roleAttribute="alert">
      <p ngProjectAs="[accordionContent]" class="c-accordion__body">
        Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia conseq duis enim velit
        mollit. Exercitation veniam consequat sunt nostrud amet. Amet minim mollit non deserunt ullamco est sit aliqua
        dolor do amet sint. Velit officia conseq duis enim velit mollit. Exercitation veniam consequat sunt nostrud
        amet.
      </p>
    </maced-accordian>

    <maced-accordian accordianId="accordianId2" [collapseLabel]="collapseLabel" [expandLabel]="expandLabel"
      [hasContentBelow]="hasContentBelow" [hasIconLeftSide]="hasIconLeftSide" [hasActions]="hasActions" roleAttribute="alert"
      preview="Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia conseq duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia conseq duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.">
      <ng-container ngProjectAs="[accordionActions]">
        <maced-button buttonId="buttonId3" color="default" size="small" shape="square" buttonType="button"
          label="Action" ariaLabel="action">
        </maced-button>
        <maced-button buttonId="buttonId4" color="default" size="small" shape="square" buttonType="button"
          label="Action" ariaLabel="action">
        </maced-button>
      </ng-container>
      <p ngProjectAs="[accordionContent]" class="c-accordion__body">
        Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia conseq duis enim velit
        mollit. Exercitation veniam consequat sunt nostrud amet. Amet minim mollit non deserunt ullamco est sit aliqua
        dolor do amet sint. Velit officia conseq duis enim velit mollit. Exercitation veniam consequat sunt nostrud
        amet.
      </p>
    </maced-accordian>
  </maced-accordian-group>
</div>